import type { PostCodeKeyboardType } from "@jti/fe-common";

import type { IStoreConfig } from "../types";

type AdditionalParameters = {
  shouldHidePostCode?: boolean;
  postCodeKeyboardType?: PostCodeKeyboardType;
};

export type PostCodeConfig = Pick<
  IStoreConfig,
  | "postcode_is_required"
  | "postcode_max_length"
  | "postcode_min_length"
  | "postcode_validate_regex"
  | "postcode_validation_enabled"
> &
  AdditionalParameters;
